import React from 'react';

function DataVerificationStep({ onSubmit, initialData = {}, onPreviousStep }) {
  const handleContinue = () => {
    onSubmit({
      data_verification_completed: true,
      completed: true
    });
  };

  return (
    <div className="data-verification-step">
      <div className="step-header">
        <h3>تأیید اطلاعات</h3>
        <p>در این مرحله اطلاعات مربوط به کدهای رهگیری، سابقه سکونت، بدهی‌های مالیاتی و مشکلات حقوقی ملک از طریق وب‌سرویس دریافت و نمایش داده خواهد شد.</p>
      </div>

      <div className="info-box">
     
        <div className="info-content">
          <h4>این قابلیت به زودی اضافه خواهد شد</h4>
          <p>در حال حاضر می‌توانید به مرحله بعد بروید. این بخش در آینده با قابلیت‌های کامل راه‌اندازی خواهد شد.</p>
        </div>
      </div>

      <div className="navigation-buttons">
        <button
          type="button"
          onClick={handleContinue}
          className="submit-button"
        >
          تأیید و ادامه
        </button>
        <button
          type="button"
          onClick={onPreviousStep}
          className="previous-button"
        >
          بازگشت
        </button>
      </div>
    </div>
  );
}

export default DataVerificationStep;
